import rules from './rules'

export default {
  data () {
    return {
      formRules: {
        idName: [{ required: true, max: 20, message: '请输入管理员姓名', trigger: 'blur' }],
        idNumber: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              if (rules.idNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入有效的身份证号'))
              }
            } else {
              callback(new Error('请输入管理员身份证号'))
            }
          },
          trigger: 'blur'
        }],
        provinceCode: [{ required: true, message: '请选择省份', trigger: 'change' }],
        cityCode: [{ required: true, message: '请选择市', trigger: 'change' }],
        youthName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value && value.length <= 50) {
              if (this.centerInfo.youthShortName && value === this.centerInfo.youthShortName) {
                callback(new Error('全称不能跟简称一致'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请输入全称(50个字以内)'))
            }
          },
          trigger: 'blur' }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
        youthShortName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value && value.length <= 20) {
              if (this.centerInfo.youthName && value === this.centerInfo.youthName) {
                callback(new Error('简称不能跟全称一致'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请输入简称(20个字以内)'))
            }
          },
          trigger: 'blur' }],
        phone: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              if (rules.mobile_phone(value)) {
                callback()
              } else {
                callback(new Error('请输入有效的手机号'))
              }
            } else {
              callback(new Error('请输入管理员手机号'))
            }
          },
          trigger: 'blur'
        }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        password: [{ required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              if (!rules.password(value)) {
                callback(new Error(this.$t('passwordLimit')))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        confirmPassword: [{ required: false,
          validator: (rule, value, callback) => {
            if (value) {
              if (this.centerInfo.password) {
                if (value === this.centerInfo.password) {
                  callback()
                } else {
                  callback(new Error('两次密码不一致'))
                }
              } else {
                if (!rules.password(value)) {
                  callback(new Error(this.$t('passwordLimit')))
                } else {
                  callback()
                }
              }
            } else {
              if (this.centerInfo.password) {
                callback(new Error('两次密码不一致'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        loginName: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              const reg = /^[a-z]{2}[0-9]{6}$/
              if (reg.test(value)) {
                callback()
              } else {
                callback(new Error('用户名以2位的小写字母开头和6位的数字组成'))
              }
            } else {
              callback(new Error('请输入用户名'))
            }
          },
          trigger: 'blur'
        }]
      }
    }
  }
}
